import { z } from "zod";

export const REGION_ENCOUNTER_TIMERS_MESSAGE =
  "region.encounter_timers" as const;

const timestampSchema = z.number().int().nonnegative().nullable();

export const regionEncounterTimersSnapshotSchema = z
  .object({
    regionId: z.string().min(1).max(80),
    regionName: z.string().min(1).max(120),
    serverTimeMs: z.number().int().nonnegative(),
    elite: z
      .object({
        monsterId: z.string().min(1).max(80),
        label: z.string().min(1).max(120),
        status: z.enum(["active", "respawning", "field", "unknown"]),
        respawnAtMs: timestampSchema,
      })
      .strict(),
    boss: z
      .object({
        monsterId: z.string().min(1).max(80),
        label: z.string().min(1).max(120),
        sealLabel: z.string().min(1).max(80),
        preparedSeals: z.number().int().nonnegative(),
        cooldownUntilMs: timestampSchema,
      })
      .strict(),
  })
  .strict();

export const regionEncounterTimersEventSchema =
  regionEncounterTimersSnapshotSchema
    .extend({
      eventId: z.string().uuid(),
      sequence: z.number().int().positive(),
    })
    .strict();

export type RegionEncounterTimersSnapshot = z.infer<
  typeof regionEncounterTimersSnapshotSchema
>;
